<template>
	<v-card-text class="mt">
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">location_city</v-icon>
			<v-toolbar-title>Departament</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn color="accent" class="mt-3 ml-3" dark @click="readOnlyMode = !readOnlyMode"
			v-if="roles.isAdministrator() && editable">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4" v-if="roles.isAdministrator()">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Nazwa</v-subheader>
				</v-flex>
				<v-flex xs7>
					<v-autocomplete
						aria-label="department"
						v-model="data"
						:items="departments"
						:readonly="readOnlyMode"
						item-text="name"
						item-value="id"
						return-object
					></v-autocomplete>
				</v-flex>
			</v-layout>
		</div>
		<div class="ma-4" v-else>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Nazwa</v-subheader>
				</v-flex>
				<v-flex xs7>
					<v-text-field
						browser-autocomplete="off"
						solo
						readonly
						v-model="data.name"
						aria-label="label for name">
					</v-text-field>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	import {Department} from "@/api/generated/Department";

	export default {
		name: "DepartmentProfileDataView",

		data() {
			return {
				readOnlyMode: true,

				data: {},

				departments: [],
			};
		},

		methods: {
			refresh() {
				Department.getList(this, successResponse => {
						this.departments = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować placówki", errorResponse);
					});
			},
		},

		created() {
			this.refresh();
		},

		watch: {
			departmentData: function () {
				this.data = this.departmentData;
			},

			readOnlyMode: function (value) {
				this.$emit("edition-status", !value, this.data);
			},
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		props: {
			departmentData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>

	.v-btn__content .v-icon {
		color: #fff !important;
	}
</style>
